export const SectionTitle = ({ title }: { title: string }) => (
  <h2 className="block font-rubik text-2xl font-bold sm:text-3xl">{title}</h2>
);
